import React, { Component } from 'react'
import get from 'lodash/get'
import uniqBy from 'lodash/uniqBy'
import withTour from '../../../../../../../components/hocs/withTour'
import ViewAverageSalary from '../../../components/ViewAverageSalary'
import AverageSalaryCardData from '../../../components/AverageSalaryCardData'
import RankingBars from '../../../components/components/RankingBars'
import CompanyCard from '../../../components/components/CompanyCard'
import sampleCategoryData from '../../../static/CategoryData'

class MobileCareerResult extends Component {
  constructor() {
    super()

    this.state = {
      activeCommonJob: 0,
      activeHighPayJob: 0,
    }

    this.getCategoryData = (categoryName) => {
      const categoryObj = {}
      sampleCategoryData.forEach((category) => {
        if (category.category === categoryName) {
          categoryObj.category = categoryName
          categoryObj.employmentGrowth = category.employmentGrowth
          categoryObj.jobs2016 = category.jobs2016
        }
      })
      return categoryObj
    }
  }

  componentWillMount() {
    this.props.onChangeResultsPage('educationPage2')
  }

  render() {
    const {
      commonJobSalaryData,
      predictedSalary,
      salaryData,
      searchType,
      searchClassification,
      salaryDistribution,
      topCompanies,
      yearsToPosition,
      topJobsSalaryData
    } = this.props

    const categoryData = this.getCategoryData(searchClassification)

    // Common jobs are too low for some searches, so add top jobs to that if below 5
    // TODO: handle relevance for top jobs
    const finalCommonJobsSalaryData =
      commonJobSalaryData && !!commonJobSalaryData.length && commonJobSalaryData.length > 5
        ? commonJobSalaryData
        : uniqBy([...commonJobSalaryData, ...topJobsSalaryData], o => o.name)

    return (
      <div>
        <div className="shadow" style={{ marginBottom: '10px' }}>
          <div>
            <div style={{ borderBottom: '1px solid #e7ecf1' }}>
              <div className="accordion" id="eyeCards">
                <div className="card" style={{ marginBottom: '0' }}>
                  <div
                    className="card-header"
                    id="headingOne"
                    style={{ backgroundColor: '#ffffff', borderBottom: '0' }}
                  >
                    <div data-toggle="collapse" data-target="#collapseOne">
                      Salary
                    </div>
                  </div>
                  <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#eyeCards"
                  >
                    {searchType === 'career' && (
                      <AverageSalaryCardData
                        predictedSalary={predictedSalary}
                        categoryData={categoryData}
                        salaryDistribution={salaryDistribution}
                        yearsToPosition={yearsToPosition}
                        isMobile={true}
                      />
                    )}
                    {searchType === 'education' && (
                      <ViewAverageSalary
                        isMobile
                        avgYearsExp={yearsToPosition}
                        predictedSalary={predictedSalary}
                        description={
                          searchType === 'education'
                            ? `from ${
                                get(salaryData, 'subvalues', []).length
                              } industries`
                            : 'year'
                        }
                        isActive={false}
                        onClick={() => {}}
                      />
                    )}
                  </div>
                </div>
                <div className="card" style={{ marginBottom: '0' }}>
                  <div
                    className="card-header"
                    id="headingTwo"
                    style={{
                      backgroundColor: '#ffffff',
                      borderTop: '1px solid rgba(0, 0, 0, 0.125)',
                      borderBottom: '0',
                    }}
                  >
                    <div
                      className="collapsed"
                      data-toggle="collapse"
                      data-target="#collapseTwo"
                    >
                      Common Jobs
                    </div>
                  </div>
                  <div
                    id="collapseTwo"
                    className="collapse"
                    aria-labelledby="headingTwo"
                    data-parent="#eyeCards"
                  >
                    <div
                      className="row mb-3 mobile-accordion-body"
                      style={{ padding: '0 16px' }}
                    >
                      <div
                        className="light-gray offset-md-4 col text-center"
                        style={{
                          marginBottom: '15px',
                        }}
                      >
                        <i
                          className="fal fa-fire mr-1"
                          style={{ color: '#FF9551' }}
                        />
                        Volume
                      </div>
                      <div className="light-gray col text-center">
                        <i
                          className="fa fa-dollar-sign mr-1"
                          style={{ color: '#68CEB7' }}
                        />
                        Salary
                      </div>
                      {finalCommonJobsSalaryData.map((job, index) => (
                        <RankingBars
                          key={`${get(job, 'name')}-${index}`}
                          name={get(job, 'name')}
                          popularity={get(job, 'count')}
                          relevance={get(job, 'relevance')}
                          salary={get(job, 'salary')}
                          type="career"
                          isMobile={true}
                        />
                      ))}
                    </div>
                  </div>
                </div>
                <div className="card" style={{ marginBottom: '0' }}>
                  <div
                    className="card-header"
                    id="headingThree"
                    style={{
                      backgroundColor: '#ffffff',
                      borderTop: '1px solid rgba(0, 0, 0, 0.125)',
                      borderBottom: '0',
                    }}
                  >
                    <div
                      className="collapsed"
                      data-toggle="collapse"
                      data-target="#collapseThree"
                    >
                      Top Companies
                    </div>
                  </div>
                  <div
                    id="collapseThree"
                    className="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#eyeCards"
                  >
                    <div
                      style={{ padding: '0 5px' }}
                      className="mobile-accordion-body"
                      id="top-companies"
                    >
                      <div className="row m-0">
                        {topCompanies.map((company) => (
                          <div key={company.name} style={{ marginTop: '25px' }}>
                            <CompanyCard
                              isMobile={true}
                              name={get(company, 'name')}
                              companyId={get(company, 'companyId')}
                              skills={get(company, 'topSkills')}
                              avgSalary={get(company, 'avgSalary')}
                            />
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const educationPage2 = [
  {
    selector: '#eyeCards',
    content: 'Click on any card that interests you to learn more',
  },
  {
    selector: '#salaryChart',
    content: 'Details about your chosen card will appear here',
  },
  {
    selector: '#search360Tabs',
    content: "Click other tabs here when you're ready for more",
  },
]

export default withTour('educationPage2', educationPage2)(MobileCareerResult)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/Career/components/mobile/MobileCareerResult.js